// Vanilla replacement for the jQuery dropdown plugin.
// API-compatible with the original $.fn.dropdown — used only by dropdown.js.
export class Dropdown {
  static _active = null

  static _hideActive() {
    if (Dropdown._active) Dropdown._active.hide()
  }

  constructor(el, opts = {}) {
    this.el = el
    this.options = Object.assign({
      trigger: null,
      displayEvent: 'click',
      hideDelay: 3000,
      mouseLeaveDelay: 500,
      toggledClass: 'active',
      showCallback: () => {},
      hideCallback: () => {},
      dismissOnDocumentClick: true,
    }, opts)
    this._hideTimer = null
    this._mouseLeaveTimer = null
    this._init()
  }

  _init() {
    const { mouseLeaveDelay, trigger, displayEvent } = this.options

    if (mouseLeaveDelay) {
      this.el.addEventListener('mouseleave', e => {
        // ignore mouseleave fired by opening a <select> inside the dropdown
        if (e.target.tagName === 'SELECT' && this.el.contains(e.target)) return
        this._mouseLeaveTimer = setTimeout(() => this.hide(), mouseLeaveDelay)
      })
      this.el.addEventListener('mouseenter', () => this._clearTimers())
    }

    if (trigger) {
      const triggerEls = trigger instanceof Element ? [trigger] : [...document.querySelectorAll(trigger)]
      triggerEls.forEach(t => {
        t.addEventListener(displayEvent, e => {
          e.preventDefault()
          if (Dropdown._active !== this) {
            e.stopPropagation()
            this.show()
          }
        })
      })
    }

    if (!Dropdown._documentListenerAdded) {
      document.addEventListener('click', e => {
        if (
          Dropdown._active &&
          Dropdown._active.options.dismissOnDocumentClick &&
          !Dropdown._active.el.contains(e.target) &&
          e.target !== Dropdown._active.el
        ) {
          Dropdown._active.hide()
        }
      })
      Dropdown._documentListenerAdded = true
    }
  }

  _clearTimers() {
    clearTimeout(this._hideTimer)
    clearTimeout(this._mouseLeaveTimer)
  }

  show() {
    if (this.el.classList.contains(this.options.toggledClass)) return
    if (this.options.hideDelay) {
      this._hideTimer = setTimeout(() => this.hide(), this.options.hideDelay)
    }
    Dropdown._hideActive()
    Dropdown._active = this
    this.el.classList.add(this.options.toggledClass)
    this.options.showCallback()
  }

  hide() {
    if (!this.el.classList.contains(this.options.toggledClass)) return
    Dropdown._active = null
    this._clearTimers()
    this.el.classList.remove(this.options.toggledClass)
    this.options.hideCallback()
  }

  destroy() {
    this._clearTimers()
    // listeners are anonymous — caller is responsible for element removal
  }
}

Dropdown._documentListenerAdded = false

